import * as types from './types';

const getReputationLevel = () => {
  return {
    type: types.GET_REPUTATION_LEVEL,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: '/publisher/getReputationLevel',
      method: 'GET'
    }
  };
};

export { getReputationLevel };
